/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-connected-systems.scss';

/* eslint-disable import/no-unresolved, import/default */

import siloConnectedSystemsTemplate from './silo-connected-systems.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloConnectedSystems', [])
    .directive('agSiloConnectedSystems', SiloConnectedSystems)
    .name;

/*@ngInject*/
function SiloConnectedSystems() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SiloConnectedSystemsController,
        controllerAs: 'vm',
        templateUrl: siloConnectedSystemsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloConnectedSystemsController($scope, $q, $translate, agTypes, siloService, userService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloId = null;
    vm.silo = null;

    vm.getConnectedSystems = getConnectedSystems;
    vm.getMapConnectedSystems = getMapConnectedSystems;

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.ctx.widgetActions = [];
            vm.ctx.hideTitlePanel = false;
            vm.ctx.assetBrowserWidgetType = agTypes.assetBrowserWidgetType.dashboard;
            vm.ctx.connectedSystemScope = true;

            vm.siloId = null;
            if (vm.ctx.stateController) {
                vm.siloId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSilo();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloId, prevSiloId) {
                    if (newSiloId && !angular.equals(newSiloId, prevSiloId)) {
                        vm.siloId = newSiloId;
                        loadSilo();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.silo ? (vm.silo.label || vm.silo.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = title + ' ' + $translate.instant('ag.aeration.aeration-systems');
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function getConnectedSystems(fetchAlarmsSeverity) {
        if (vm.siloId) {
           return siloService.getSiloConnectedSystems(vm.siloId, fetchAlarmsSeverity);
        } else {
            return $q.when([]);
        }
    }

    function getMapConnectedSystems(fetchAlarmsSeverity) {
        if (vm.siloId) {
            return siloService.getMapSiloConnectedSystems(vm.siloId, fetchAlarmsSeverity);
        } else {
            return $q.when([]);
        }
    }

    function loadSilo() {
        vm.silo = null;
        reset();
        if (vm.siloId) {
            vm.loading = true;
            siloService.getSilo(vm.siloId).then(
                function success(silo) {
                    vm.silo = silo;
                    vm.loading = false;
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function reset() {
    }

}